import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  searchMessage,
  tags,
  users,
  usersLast,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  statusId,
  whatsappId,
  whatsappIdLast,
  withUnreadMessages,
  archived,
  orderByRecent,
  adReferralSourceId,
  beforeUpdatedAt,
  beforeId
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count , setCount] = useState(0);
  const [total , setTotal] = useState(0);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          const { data } = await api.get("/tickets", {
            params: {
              searchParam,
              searchMessage,
              pageNumber,
              tags,
              users,
              usersLast,
              status,
              date,
              updatedAt,
              statusId,
              showAll,
              queueIds,
              whatsappId,
              whatsappIdLast,
              withUnreadMessages,
              archived,
              orderByRecent,
              adReferralSourceId,
              beforeUpdatedAt,
              beforeId
            },
          });

          setTickets(data.tickets);
          setHasMore(data.hasMore);
          setCount(data.count);
          setTotal(data.total);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    searchMessage,
    tags,
    users,
    usersLast,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    statusId,
    queueIds,
    whatsappId,
    whatsappIdLast,
    withUnreadMessages,
    archived,
    orderByRecent,
    adReferralSourceId,
    beforeUpdatedAt,
    beforeId
  ]);

  return { tickets, loading, hasMore, count, total };
};

export default useTickets;
